import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import Event from '../../darkmatter/Event';

export default class EventButton extends React.Component {
  render() {
    const { event, children, ...rest } = this.props;
    return (
      <Event event={event} eventType="click">
        <Button {...rest}>{children}</Button>
      </Event>
    );
  }
}

EventButton.propTypes = {
  event: PropTypes.shape({
    category: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.number,
    nonInteraction: PropTypes.bool,
  }).isRequired,
};
